import parseHtml from "html-react-parser";
import React from "react";

import { ModelState } from "../../interfaces/modelState";

export const VALIDATION_MESSAGE_CLASS_NAME = "validationMessageWrapper";

interface Props {
  id?: string;
  property?: string;
  modelState?: ModelState | null;
}

export const ValidationMessage = ({ property, modelState, id }: Props) => {
  const getMessages = () => {
    if (!modelState) {
      return [];
    }

    const propertyErrors = Object.keys(modelState).find((key) => key.toLowerCase() === property?.toLowerCase());

    if (propertyErrors) {
      return modelState[propertyErrors];
    }

    return [];
  };

  const messages = getMessages();

  if (messages.length === 0) {
    return null;
  }

  return (
    <div id={id} className={VALIDATION_MESSAGE_CLASS_NAME}>
      {messages.map((message, i) => (
        <span key={`field_validation_error_${i}`} className="field-validation-error">
          {parseHtml(message)}
        </span>
      ))}
    </div>
  );
};
